import { translations as enTranslations } from "./translations.en";

export const getTranslations = () => {
    return enTranslations;
}